import Parse from "parse";

export const getUserPreferences = async () => {
  return Parse.Cloud.run("getUserPreferences");
};

export const getSpecificUserPreferences = async (data) => {
  return Parse.Cloud.run("getSpecificUserPreferences", data);
};
